import { TeamManagerLabel } from "../../components/TeamManagerLabel";

interface DuesRow {
  name: string;
  status: "due" | "paid";
  managerLabel?: string;
}

interface DuesTeamListProps {
  teams: DuesRow[];
  isAuthenticated: boolean;
  /** The team whose status is being saved; every toggle is disabled until it's done. */
  savingName: string | null;
  onToggle: (name: string) => void;
}

/** One row per team: the team name and a due/paid status. When logged in the
 * status pill is itself the control — clicking it flips that one team between
 * due and paid. No confirm step: unlike a destructive action, this is a
 * single field that's trivially reversible by clicking again. When logged
 * out it's a plain, non-interactive tag. */
export function DuesTeamList({ teams, isAuthenticated, savingName, onToggle }: DuesTeamListProps) {
  if (teams.length === 0) {
    return <p className="payout-awards__empty">No teams on this season's roster yet.</p>;
  }

  return (
    <ul className="dues-list">
      {teams.map((team) => (
        <li key={team.name} className="dues-list__row">
          <span className="dues-list__name">
            {team.name}
            <TeamManagerLabel label={team.managerLabel} />
          </span>
          {isAuthenticated ? (
            <button
              type="button"
              className={`tag tag--${team.status} dues-list__status-toggle`}
              onClick={() => onToggle(team.name)}
              disabled={savingName !== null}
              aria-busy={savingName === team.name}
              aria-label={`${team.name}: ${team.status}. Mark ${
                team.status === "due" ? "paid" : "due"
              }.`}
            >
              {savingName === team.name ? "saving…" : team.status}
            </button>
          ) : (
            <span className={`tag tag--${team.status}`}>{team.status}</span>
          )}
        </li>
      ))}
    </ul>
  );
}
